<template>
  <div class="reupload-box">
    <input
      ref="file"
      type="file"
      accept="image/*,.pdf"
      class="reupload-box__file hidden"
      @change="handleFileChange"
    />
    <div class="reupload-box__title">{{ reuploadTitle }}</div>

    <div class="reupload-box__upload-wrapper" @click="uploadClick">
      <span class="reupload-box__input-label">{{ reuploadButton }}</span>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { submitDtfEvent } from "common/utils/mixpanel/submit-dtf-events";
import { useDtfStore } from "./store";

export default {
  name: "ReuploadBox",
  props: {
    index: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapState(useDtfStore, ["printAsIs", "pdpType"]),
    reuploadTitle() {
      if (this.printAsIs) {
        return "Re-upload a gang sheet in the correct size";
      }
      return "Re-upload valid artwork";
    },
    reuploadButton() {
      if (this.printAsIs) {
        return "Re-upload a gang sheet";
      }
      return "Choose file";
    }
  },
  methods: {
    ...mapActions(useDtfStore, ["addFilesToQueue"]),
    trackAddFileAreaClick() {
      submitDtfEvent("replace_artwork_file_clicked", {
        page: "pdp",
        pdp_type: this.pdpType
      });
    },
    uploadClick() {
      this.trackAddFileAreaClick();
      this.$refs.file.click();
    },
    handleFileChange(event) {
      const { files } = event.target;

      if (!files.length) return;

      this.addFilesToQueue({ files, isDropEvent: false, artworkIndex: this.index });
      this.$refs.file.value = "";
    }
  }
};
</script>

<style scoped lang="scss">
@import "frontend/init/jiffy/settings.scss";

.reupload-box {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &__title {
    text-align: center;
    font-weight: bold;
    font-size: 14px;
  }

  &__upload-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  &__input-label {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: 15px 0;
    padding: 10px 16px;
    border-radius: 4px;
    background: $primary-light;
    color: $white;
    font-weight: bold;
  }
}
</style>
